import { atom } from 'jotai'

export const recordAtom = atom({})
export const isDrawerOpenAtom = atom(false)
